/**
 * SEO Optimierung: Minimierte Inhalte mit „hidden=until-found“ zugänglich machen.
 * Erweitert Bootstrap collapse `[hidden=until-found]`-Attribut mit toggle
 *
 * @see https://developer.chrome.com/docs/css-ui/hidden-until-found?hl=de
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/hidden
 */
(function ($) {

  var Event = {
    PJAX_DATA_API: 'pjax:end'
  };
  var Selector = {
    DATA_SPY: '[data-toggle=collapse]'
  };

  var fixElements = function () {
    return this.each(function () {
      var $element = $(this);
      var selector = $element.attr('data-target');
      if (!selector) {
        selector = $element.attr('href')
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
      }

      var $target = $(selector);
      var target = $target[0];

      /**
       * An element receives a beforematch event when it is in the hidden until found state
       * and the browser is about to reveal its content because the user has found the content
       * through the "find in page" feature or through fragment navigation.
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/beforematch_event
       */
      $target.on('beforematch', function () {
        $target.trigger('show.bs.collapse');
      })

      $target.on('show.bs.collapse swr:collapse:showing', function (event) {
        if (event.target !== this) {
          return;
        }
        target.removeAttribute('hidden');
      });
      $target.on('hidden.bs.collapse swr:collapse:hidden', function (event) {
        if (event.target !== this) {
          return;
        }
        target.setAttribute('hidden', 'until-found');
      });

      if (
        $element.hasClass('collapsed') && (
          !target.hasAttribute('hidden') ||
          'until-found' !== target.hidden
        )
      ) {
        target.setAttribute('hidden', 'until-found');
      }
    });
  };

  $('#content').find(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    fixElements.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      fixElements.call($element);
    });
  });

})(window.jQuery);
